import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import { BlockProps, LwBlock } from 'redesign';
import { useGetFlexPoolsForFlexWorker } from 'hq/components/views/flexWorkers/flex-worker-detail/tabs/flex-pools/use-get-flex-pools-for-flex-worker';
import { RenderUnsettledUI } from 'shared/components';
import { useTranslation } from 'react-i18next';
import { useSiteDetection } from 'shared/hooks';

type FlexWorkerFlexPoolProps = {
  flexWorkerId: string;
};

export const EmployeeFlexPools = ({ flexWorkerId }: FlexWorkerFlexPoolProps) => {
  const { site } = useSiteDetection();
  const flexPoolsQuery = useGetFlexPoolsForFlexWorker(site, flexWorkerId);
  const { t } = useTranslation('ogp-screen-specific');

  if (flexPoolsQuery.status !== 'success') {
    return <RenderUnsettledUI data={flexPoolsQuery} />;
  }

  const blocks: BlockProps[] = flexPoolsQuery.data.map((flexPool) => ({
    id: flexPool.id,
    title: flexPool.name,
    subtitle: `${flexPool.companyName}: ${flexPool.departmentNames.join(', ')}`,
  }));

  if (blocks.length === 0) {
    return <Typography> {t('employee_flexpools.no_flexpools_for_flexworker')}</Typography>;
  }

  return (
    <Grid container spacing={4}>
      {blocks.map((block) => {
        return (
          <Grid item xs={4} key={block.id}>
            <LwBlock {...block} />
          </Grid>
        );
      })}
    </Grid>
  );
};
